import { CommonErrorCode, ProjectErrorCode } from '../helpers/ErrorCodes';
import { L10n } from '../L10n/L10n';
import { IProjectBase } from '../models/IProjectInfo';
import { IErrorItem } from '../models/MultipleItemResult';
import { Module } from '../Module';
import { IErrorDetail } from './ContentActionNotification';

export class ProjectErrors {

  public static $inject = ['$state', '$translate'];

  constructor(
    private $state: ng.ui.IStateService,
    private $translate: ng.translate.ITranslateService) { }

  public errorDetailsFor(projectErrorItem: IErrorItem<IProjectBase>): IErrorDetail {
    return {
      itemName: projectErrorItem.item.name,
      itemUrl:
        projectErrorItem.error.code === CommonErrorCode.ProjectNotFound
          ? null
          : this.projectUrl(projectErrorItem.item),
      errorMessage: this.errorMessageFor(projectErrorItem)
    };
  }

  private projectUrl(project: IProjectBase): string {
    return this.$state.href('main.site.content.project', { id: project.id });
  }

  public errorMessageFor(errorItem: IErrorItem<IProjectBase>) {
    const project = errorItem.item;
    switch (errorItem.error.code) {
      case ProjectErrorCode.ProjectChangeOwnerDisabled:
        return this.$translate.instant('errorProjectChangeOwnerDisabled');
      case ProjectErrorCode.ProjectDescriptionGreaterThanMaxLength:
        return this.$translate.instant('errorProjectDescriptionTooLong');
      case ProjectErrorCode.ProjectNameAlreadyExists:
        return this.$translate.instant('errorProjectNameAlreadyExists');
      case CommonErrorCode.ProjectNotFound:
        return this.$translate.instant('errorProjectNotFound', { PROJECT_NAME: L10n.elideIfLong(project.name) });
      case CommonErrorCode.CallingUserInsufficientPermissions:
        return this.$translate.instant('errorProjectInsufficientPermissions');
      case ProjectErrorCode.ProjectNameAlreadyExistsInDestinationProject:
          return this.$translate.instant('errorProjectNameAlreadyExistsAtLocation', { PROJECT_NAME: L10n.elideIfLong(project.name) });

      default:
        return this.$translate.instant('errorUnknown');
    }
  }

}

Module.instance().service('ProjectErrors', ProjectErrors);
